<template>
  <div :id="'task-' + schema.model">
    <div :id="'task-' + schema.model">
      <multiselect
        :id="'input-' + schema.model"
        v-model="multiselectValue"
        :options="optionsList"
        :label="viewOption"
        :track-by="trackBy"
        :multiple="multiple"
        :disabled="disabled"
        :placeholder="placeholder"
        @input="updateValue"
        @close="onBlur(onBlurEvent)"
      >
      </multiselect>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { abstractField } from 'vue-form-generator'
import Multiselect from 'vue-multiselect'

export default {
  name: 'field-metadata-multiselect',
  components: {
    Multiselect
  },
  mixins: [abstractField],
  computed: {
    mapOptions () { return 'name' },
    viewOption () { return 'name' },
    trackBy () { return 'id' },
    multiple () { return false },
    placeholder() { return _.has(this.value, 'name') ? this.value.name : 'wybierz' },
    selectOptions() {
      return this.schema.selectOptions || {}
    },
    optionsList() {
      let values = this.schema.hasOwnProperty('settings') && this.schema.settings.hasOwnProperty('values') ? this.schema.settings.values : this.schema.values
      if (typeof values == 'function') {
        return values.apply(this, [this.model, this.schema])
      } else {
        return values
      }
    },
    multiselectValue: {
      get () {
        let val = null
        let modelValue = this.getModelValue(this.schema.model)
        let optionItem = this.getOption(modelValue)

        val = optionItem !== undefined ? { id: modelValue, name: optionItem.name } : this.value

        return val
      },
      set (newVal) {
        return newVal
      }
    },
    onBlurEvent () {
      return { target: this.$el }
    }
  },
  beforeUpdate(){
    this.correctValueWhenMultiSelect()
  },
  created() {
    this.correctValueWhenMultiSelect()
  },
  methods: {
    getModelValue (objectPath) {
      return _.get(this.model, objectPath, null)
    },
    updateValue (value) {
      this.value = value
    },
    correctValueWhenMultiSelect() {
      if (
        this.schema.selectOptions &&
        this.schema.selectOptions.multiple &&
        !this.value
      ) {
        this.value = []
      }
    },
    getOption(value, searchKey) {
      return this.optionsList.find(o => o.id === value)
    }
  }
}
</script>
